// src/pages/Overview/Overview.tsx

import { Alert, AlertTitle, Collapse, Typography } from '@mui/material'

import { useAppConfig, useMaintenanceMode } from '../../../hooks'

export const Maintenance = () => {
  const maintenanceMode: boolean = useMaintenanceMode()

  const { appConfig } = useAppConfig()

  return (
    <Collapse in={maintenanceMode === true}>
      <Alert severity={'info'}>
        <AlertTitle>WARTUNGSARBEITEN</AlertTitle>

        <Typography sx={{ whiteSpace: 'pre-line', wordWrap: 'break-word' }}>
          {appConfig?.maintenanceMessage}
        </Typography>
      </Alert>
    </Collapse>
  )
}
